import { Text, View } from 'react-native'
import { styled } from '~/utils'

export const Wrapper = styled(View, theme => {
  return {
    base: {
      position: 'absolute',
      zIndex: theme.zindexOverlay,
    },
  }
})

export const Container = styled(View, theme => {
  return {
    base: {
      gap: theme.sizingMicro,
      minWidth: theme.sizingExtrasmall * theme.sizingMini,
      maxWidth: theme.sizingMediumlarge * theme.sizingMini,
      backgroundColor: theme.colorFillNeutralDefault,
      borderColor: theme.colorBorderNeutralDefault,
      borderWidth: theme.borderWidthQuarterpulse,
      borderRadius: theme.borderRadiusLargecontainer,
      padding: theme.paddingInsetFourpulse,

      shadowColor: '#71768E',
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.24,
      shadowRadius: 8,
      elevation: 4,
      alignSelf: 'flex-start',
    },
  }
})

export const Description = styled(Text, theme => {
  return {
    base: {
      color: theme.colorTextNeutralDefault,
      fontFamily: theme.fontFamily.regular,
      fontSize: theme.fontSizeThreepulse,
    },
  }
})
